import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeBlock = ({ node, inline, className, children, ...props }) => {
  const match = /language-(\w+)/.exec(className || '');
  const code = String(children).replace(/\n$/, '');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // reset after 2 seconds
  };

  if (!inline && match) {
    return (
      <Box sx={{ position: 'relative', marginBottom: '24px' }}>
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: copied ? '#19b594' : '#e0e0e0',
            color: copied ? '#fff' : '#000',
            padding: '4px 10px',
            borderRadius: '4px',
            fontSize: '0.8rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: copied ? '#19b594' : '#d0d0d0',
            },
          }}
          onClick={handleCopy}
        >
          {copied ? 'Copied' : 'Copy'}
        </Box>
        <SyntaxHighlighter
          style={materialLight}
          language={match[1]}
          PreTag="div"
          {...props}
        >
          {code}
        </SyntaxHighlighter>
      </Box>
    );
  }

  return (
    <Box
      component="code"
      sx={{
        backgroundColor: '#f5f5f5',
        padding: '2px 4px',
        borderRadius: '4px',
        fontFamily: 'monospace',
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default CodeBlock;
